// 城市列表
export const sys_gt_citycounty_GetDataList = "/Areas/sys_gt_citycounty/GetDataList"
// 新增
export const sys_gt_citycounty_AddData = "/Areas/sys_gt_citycounty/AddData"
// 修改
export const sys_gt_citycounty_UpdaData = "/Areas/sys_gt_citycounty/UpdaData"
// 删除
export const sys_gt_citycounty_DeleteData = "/Areas/sys_gt_citycounty/DeleteData"
